import { Action, on } from '@ngrx/store';
import { createImmerReducer } from 'ngrx-immer/store';
import { SpecializationPickerState } from "./state";
import * as Actions from './actions';


let initialState =  <SpecializationPickerState> {
    expandedSpecializationIds: [],
    query: null,
    selectedSpecializationIds: []
};

const reducer = createImmerReducer(initialState,
    on(Actions.toggleExpandHeadSpecialization, (state, { payload }) => {
        const specializationId = payload.specializationId;
        const expandedSpecializationIds = state.expandedSpecializationIds;
        
        if(expandedSpecializationIds.some(c => c == specializationId)){
            state.expandedSpecializationIds = expandedSpecializationIds.filter(c => c != specializationId);
        }
        else {
            state.expandedSpecializationIds.push(specializationId);
        }

        return state;
    }),

    on(Actions.selectSpecialization, (state, { payload }) => {
        state.selectedSpecializationIds = state.selectedSpecializationIds.filter(c => c != payload.specializationId);
        state.selectedSpecializationIds.push(payload.specializationId);

        return state;
    }),

    on(Actions.unselectSpecialization, (state, { payload }) => {
        state.selectedSpecializationIds = state.selectedSpecializationIds.filter(c => c != payload.specializationId);

        return state;
    }),

    on(Actions.removeSpecialization, (state, { payload }) => {
        state.selectedSpecializationIds = state.selectedSpecializationIds.filter(c => c != payload.specializationId);

        return state;
    }),

    on(Actions.filterSpecializations, (state, { payload }) => {
        state.query = payload.query;

        return state;
    }),

    on(Actions.resetSpecializationFilter, (state, _) => {
        state.query = '';

        return state;
    }),

    on(Actions.loadSpecializations, (state, { payload }) => {
        state.selectedSpecializationIds = payload.specializationIds;

        return state;
    })
);


export function specializationPickerReducer(state: SpecializationPickerState | undefined, action: Action){
    return reducer(state, action);
}